import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import BrowserView from '../utils/BrowserView'
import MobileView from '../utils/MobileView'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 320px;
  grid-gap: ${props => props.theme.spacing * 3}px;
`

const MainContainer = styled.div`
  /* padding: 16px 24px; */
`

const LayoutInplay = props => {
  const { children } = props

  return (
    <>
      {/*
       * Empty div that matches toolbar min height and
       * pushes content down
       */}
      <BrowserView>
        <Container>
          <MainContainer>{children}</MainContainer>
        </Container>
      </BrowserView>
      <MobileView>
        <MainContainer>{children}</MainContainer>
      </MobileView>
    </>
  )
}

LayoutInplay.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutInplay
